export interface FollowUpPlanUploadSubmission {
	followUpPlanId: string;
	followUpPlanVersion: number;
	uploads: { id: string; fileName: string }[];
}

export const FOLLOW_UP_PLAN_UPLOAD_VALIDATORS = {
	accept: ".pdf,.docx,.doc",
	maxFileSize: 50 * 1024 * 1024,
} as const;

export const FOLLOW_UP_PLAN_UPLOAD_MAX_FILES = 20;
